module.exports = __webpack_public_path__ + "static/img/ias.4912928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ias.png
// module id = 7J0g
// module chunks = 0